import { FC, ReactNode } from 'react';
import { styled } from '@mui/material/styles';

export interface LayoutBodyProps {
  children: ReactNode;
  'data-elm'?: string;
}

const StyledBody = styled('main', {
  name: 'Layout',
  slot: 'Body',
})(({ theme }) => ({
  height: '100%',
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'row',
  overflowY: 'auto',
  [theme.breakpoints.between('xs', 'md')]: {
    flexDirection: 'column',
  },
}));

const LayoutBody: FC<LayoutBodyProps> = ({ children, 'data-elm': dataElm }) => {
  return <StyledBody data-elm={dataElm}>{children}</StyledBody>;
};

export default LayoutBody;
